import React, { useRef, useState, useEffect, FC } from 'react';
import { Tooltip, Typography, TypographyProps } from '@mui/material';
import useStyles from './styles';
import cx from 'classnames';
import CustomTypography from '../CustomTypography';

export interface ITypographyProps extends TypographyProps {
  isContrastColor?: boolean;
  isDarkTextColor?: boolean;
  darkModeColor?: string;
}

interface IEllipsisTooltip {
  text: string;
  maxWidth?: number;
  className?: string;
  typographyProps?: ITypographyProps
}

const EllipsisTooltip: FC<IEllipsisTooltip> = ({ text, maxWidth, className, typographyProps }) => {
  const textRef = useRef(null);
  const [isOverflowed, setIsOverflowed] = useState(false);

  const classes = useStyles({ maxWidth, isOverflowed });

  useEffect(() => {
    const observer = new ResizeObserver(() => {
      if (textRef.current) {
        const { clientWidth, scrollWidth } = textRef.current;
        setIsOverflowed(clientWidth < scrollWidth);
      }
    });

    if (textRef.current) {
      observer.observe(textRef.current);
    }

    return () => {
      if (textRef.current) {
        observer.unobserve(textRef.current);
      }
    };
  }, []);

  return (
    <Tooltip
      title={<Typography variant="body1">{text}</Typography>}
      disableHoverListener={!isOverflowed}
      classes={{ tooltip: classes.tooltip }}
    >
      <CustomTypography
        ref={textRef}
        noWrap
        className={cx(classes.text, className)}
        {...typographyProps}
      >
        {text}
      </CustomTypography>
    </Tooltip>
  );
};

export default EllipsisTooltip;
